import { Flex } from 'antd';
import { observer } from 'mobx-react';
import { FC } from 'react';
import { $class } from '../../../../../../utils';
import * as styles from './index.module.scss';

interface IProps {
  tags: string[];
  color?: 'blue' | 'neutral';
}

const TagList: FC<IProps> = ({ tags, color = 'blue' }) => {
  if (!tags?.length) return null;

  return (
    <Flex align="center" gap={8} wrap>
      {tags.map((tag, index) =>
        tag ? (
          <p key={`${tag}-${index}`} className={$class(styles.tag, styles[color])}>
            {tag}
          </p>
        ) : null
      )}
    </Flex>
  );
};

export default observer(TagList);
